enum PetsInsuranceProcessStepEnum {
  RATER = 0, // Tarificacion
  POLICY_HOLDER_FIRST = 1, // Tomador
  DOCUMENTS = 2, // Documentos
  POLICY_HOLDER_SECOND = 3, // POLICY HOLDER
  PETS = 4,
  CIVIL_LIABILITY = 5,
  PAYMENT = 6, // MediosPago
  SIGN = 7, // Firma
  EMISSION = 8 // Emision
}

export default PetsInsuranceProcessStepEnum
